<template>
  <div class="vr360-app-header__center">
    <template v-if="state === 'publicStream'">
      <p class="vr360-text-reg vr360-app-header__center__title">Stream
        <span class="vr360-live" v-if="currentStream.live">
          <span class="vr360-text-caption">Live</span>
        </span>
      </p>
    </template>
    <template v-if="state === 'myStream'">
      <p class="vr360-text-reg vr360-app-header__center__title">My stream
        <span class="vr360-live" v-if="currentStream.live">
          <span class="vr360-text-caption">Live</span>
        </span>
      </p>
    </template>
    <template v-if="state === 'createStream'">
      <p class="vr360-text-reg vr360-app-header__center__title">New stream</p>
    </template>
    <template v-if="state === 'editStream'">
      <p class="vr360-text-reg vr360-app-header__center__title">Stream editing</p>
    </template>
    <template v-if="state === 'profile'">
      <p class="vr360-text-reg vr360-app-header__center__title">Profile settings</p>
    </template>
    <template v-if="state === 'editProfile'">
      <p class="vr360-text-reg vr360-app-header__center__title">Profile</p>
    </template>
    <template v-if="state === 'finish'">
      <p class="vr360-text-reg vr360-app-header__center__title">New stream</p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "centerHeader",
  data() {
    return {
      state: null,
      linkToBack: null
    };
  },
  created() {
    this.checkToShow(this.$route.name);
  },
  methods: {
    checkToShow(name) {
      switch (name) {
        case "ItemMyStream":
          this.state = "myStream";
          break;
        case "ItemPublicStream":
          this.state = "publicStream";
          break;
        case "CreateStream":
          this.state = "createStream";
          break;
        case "EditStream":
          this.state = "editStream";
          break;
        case "FinishStream":
          this.state = "finish";
          break;
        case "MenuProfile":
          this.state = "profile";
          break;
        case "EditProfile":
          this.state = "editProfile";
          break;
        default:
          this.state = null;
          break;
      }
    }
  },
  watch: {
    $route(to) {
      this.checkToShow(to.name);
    }
  },
  computed: {
    ...mapGetters({
      currentStream: "stream/currentStream"
    })
  }
};
</script>

<style lang="scss">
</style>
